import styles from './public-badge.module.css';

export function PublicBadge() {
  return <span className={styles.badge}>公開</span>;
}
